import config from '../config';
import { showStaticDevice } from "../common";

export default function scene1Intro() {
  const tlScroll = gsap.timeline({
    scrollTrigger: {
      id: "section-1-header",
      trigger: "#scene-intro-header",
      start: function(){
        if (config.mobileLayout){
          return "top+=10 top";
        }
        return "top top+=1";
      },
      end: function(){
        if (config.mobileLayout){
          return `+=${config.scrollSpanMobile / 2}`;
        }
        return `+=${config.scrollSpan}`;
      },
      pin: true,
      pinSpacing: true,
      onEnter: showStaticDevice,
      onEnterBack: function(){
        showStaticDevice();
        gsap.set("#device-screen-video-wrapper", {
          display: 'none',
        });
      },
      // markers: true,
    },
  });
  tlScroll.set("#device-screen-video-wrapper", {
    autoAlpha: 0,
    display: "none",
  });
  tlScroll.addLabel("headerStart", "+=1");
  tlScroll.to(".scene-intro-header-first", {
    duration: 1,
    yPercent: -20,
    autoAlpha: 0,
  });
}